// Linha do relatório "Produtos com Venda": metadados + uma chave por tamanho
// com a quantidade vendida. colorId vem somado no agrupamento da API, então
// não é quantidade.
const NON_ITEM_FIELDS = ["product", "avatar", "color", "colorRef", "colorId", "total", "id"];

// Soma todos os itens (quantidades por tamanho) da linha.
export function sumRowItems(row) {
  if (!row) return 0;
  return Object.entries(row).reduce((total, [key, value]) => {
    if (NON_ITEM_FIELDS.includes(key)) return total;
    const qty = Number(value);
    return Number.isFinite(qty) ? total + qty : total;
  }, 0);
}

export function withRowTotal(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => ({ ...row, total: sumRowItems(row) }));
}
